import { useState } from 'react';
import Header from '../../components/Header';
import Login from '../../components/Login';
import './Legal.css';

// 이용약관 / 개인정보처리방침 공용 레이아웃.
// 헤더는 홈과 동일한 공용 Header 컴포넌트를 그대로 사용해 통일감을 유지한다.
export default function LegalLayout({ children }) {
  const [showLogin, setShowLogin] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div className="legal-page">
      <Header
        showPopup={showPopup}
        onClosePopup={() => setShowPopup(false)}
        onLoginClick={() => setShowLogin(true)}
      />
      <div className="legal-container">{children}</div>
      <Login isOpen={showLogin} onClose={() => setShowLogin(false)} />
    </div>
  );
}
